import { ApprovalProcessReturnTo, normalizeApprovalProcessReturnTo } from "./approval-process-navigation.util";

export type ApprovalProcessAccessSource = "page" | "modal";

export const APPROVAL_PROCESS_URL_ACCESS_ACTIVITY = "approval_process_url_access";

export function accessSourceFromReturnTo(
  returnTo?: ApprovalProcessReturnTo | string | null
): ApprovalProcessAccessSource {
  return normalizeApprovalProcessReturnTo(returnTo) === "page" ? "page" : "modal";
}

export function withAccessSource(
  options: Record<string, unknown> | string | undefined | null,
  source: ApprovalProcessAccessSource
): string {
  const payload = parseFluxOptions(options);

  return JSON.stringify({
    ...payload,
    access_source: source,
  });
}

export function buildFluxOptionsPayload(
  options: Record<string, unknown> | string | undefined | null,
  returnTo?: ApprovalProcessReturnTo | string | null
): string {
  return withAccessSource(options, accessSourceFromReturnTo(returnTo));
}

function parseFluxOptions(options: Record<string, unknown> | string | undefined | null): Record<string, unknown> {
  if (options == null) {
    return {};
  }

  if (typeof options === "string") {
    if (!options.trim()) {
      return {};
    }

    try {
      const parsed = JSON.parse(options) as unknown;
      return typeof parsed === "object" && parsed !== null && !Array.isArray(parsed)
        ? (parsed as Record<string, unknown>)
        : {};
    } catch {
      return {};
    }
  }

  return { ...options };
}
